import { Flex } from '../Flex/Flex';
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';
import './Input.css';

export function TextInput(
  props: React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >
) {
  return <input {...props} className={`input ${props.className ?? ''}`} />;
}

export function SelectInput(
  props: React.DetailedHTMLProps<
    React.SelectHTMLAttributes<HTMLSelectElement>,
    HTMLSelectElement
  >
) {
  return <select {...props} className={`select ${props.className ?? ''}`} />;
}

export function Label(
  props: React.DetailedHTMLProps<
    React.LabelHTMLAttributes<HTMLLabelElement>,
    HTMLLabelElement
  >
) {
  return <label {...props} className={`label ${props.className}`} />;
}

export function LabelLg(
  props: React.DetailedHTMLProps<
    React.LabelHTMLAttributes<HTMLLabelElement>,
    HTMLLabelElement
  >
) {
  return <label {...props} className="label lg" />;
}

type InputField = {
  label: string;
  value?: string;
  checked?: boolean;
  type: React.HTMLInputTypeAttribute;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  accept?: string;
  multiple?: boolean;
  isLoading?: boolean;
  id: string;
};

function InputField({
  label,
  value,
  type,
  onChange,
  id,
  accept,
  checked,
  isLoading,
  ...props
}: InputField) {
  return (
    <Flex $flexDirection="column">
      <Label htmlFor={id} className="label">
        {label}
      </Label>
      <Flex $flexDirection="row" $alignItems="center">
        {isLoading && <LoadingSpinner />}
        <input
          id={id}
          value={value}
          type={type}
          checked={checked}
          onChange={onChange}
          className="input-field"
          accept={accept}
          {...props}
        />
      </Flex>
    </Flex>
  );
}

export default InputField;
